import { useEffect, createElement, useState } from 'react';
import { Tab, Form, DatePicker2, Input } from '@alifd/next';
import { bpmnStore } from '@/store';
import { useLocalObservable, observer } from 'mobx-react';
const CustomeProperties = observer(() => {
    const { wofrkflowInfos: { taskFlowVOS = [], activeActivityIds = [] }, clickedElement, } = useLocalObservable(() => bpmnStore);
    const [formValue, setFormValue] = useState({
        nodeName: 'N/A',
        planExeName: 'N/A',
        approveResultCode: 'N/A',
        actualExeName: 'N/A',
        approvalTime: 'N/A',
    });
    useEffect(() => {
        if (clickedElement) {
            const { id } = clickedElement;
            const { nodeName = 'N/A', planExeName = 'N/A', approveResultCode = 'N/A', actualExeName = 'N/A', approvalTime = 'N/A', } = taskFlowVOS?.find((item) => item.nodeCode === id) || {};
            setFormValue({
                nodeName,
                planExeName,
                approveResultCode,
                actualExeName,
                approvalTime,
            });
        }
    }, [clickedElement, taskFlowVOS]);
    useEffect(() => {
        const { nodeName = 'N/A', planExeName = 'N/A', approveResultCode = 'N/A', actualExeName = 'N/A', approvalTime = 'N/A', } = taskFlowVOS?.find((item) => item.nodeCode === activeActivityIds?.[0]) || {};
        setFormValue({
            nodeName,
            planExeName,
            approveResultCode,
            actualExeName,
            approvalTime,
        });
    }, [activeActivityIds, taskFlowVOS]);
    return (createElement(Tab, { shape: "wrapped" },
        createElement(Tab.Item, { title: "\u8282\u70B9\u4FE1\u606F", key: "1" },
            createElement("div", { style: { padding: 20 } },
                createElement(Form, { colon: true, isPreview: true, value: formValue, labelAlign: "left", labelCol: { fixedSpan: 4 }, inline: true },
                    createElement(Form.Item, { name: "nodeName", label: "\u8282\u70B9\u540D\u79F0" },
                        createElement(Input, null)),
                    formValue.actualExeName ? (createElement(Form.Item, { name: "actualExeName", label: "\u5BA1\u6279\u4EBA" },
                        createElement(Input, null))) : (createElement(Form.Item, { name: "planExeName", label: "\u8BA1\u5212\u6267\u884C\u4EBA" },
                        createElement(Input, null))),
                    createElement(Form.Item, { name: "approveResultCode", label: "\u5BA1\u6279\u7ED3\u679C" },
                        createElement(Input, null)),
                    createElement(Form.Item, { name: "approvalTime", label: "\u5BA1\u6279\u65F6\u95F4" },
                        createElement(DatePicker2, { format: 'YYYY-MM-DD HH:mm:ss' })))))));
});
export default CustomeProperties;
